<div class="content center-content">
    <div class="column-flex">
        <div class="dialog-title">
            {{ 'print.main.dialog.title' | translate }}
        </div>
        <div class="content-container">
            <div class="option-container">
                <div class="option-left-container">
                    {{ 'print.main.dialog.select.title' | translate }}
                </div>
                <mat-radio-group
                    class="option-right-container"
                    [(ngModel)]="selectedPrintOption"
                    (change)="onPrintOptionChange($event.value)">
                    <mat-radio-button
                        *ngFor="let option of printOptions"
                        [value]="option.value"
                        disableRipple
                    >
                        {{ option.label | translate }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
        <div class="footer-container">
            <div class="buttons-container">
                <div class="button" (click)="cancel()">
                    {{ 'print.dialog.button.cancel' | translate }}
                </div>
                <div
                    class="button button-print"
                    [class.disabled]="isPrinting"
                    (click)="print()">
                    {{ 'dlg.select' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>